const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "068---Deadlines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m59 41c.0064759 8.2649444-5.6121423 15.4739855-13.6284175 17.4861183-8.0162753 2.0121328-16.373391-1.6889159-20.2708671-8.9771961-3.897476-7.2882802-2.3352976-16.2937642 3.7891914-21.8435374 6.1244889-5.5497732 15.2398665-6.2198742 22.1100932-1.6253848 4.9967354 3.3385837 7.9977864 8.950549 8 14.96z",
    fill: "#040040",
    "data-original": "#02a9f4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m51 26.04c-2.9561714-1.9866665-6.4382918-3.0452311-10-3.04-.487 0-.964.035-1.441.073 9.3108938.805857 16.4541222 8.6069123 16.438742 17.9526018-.0153802 9.3456894-7.1842463 17.1231914-16.497742 17.8983982.5.041.994.076 1.5.076 7.9245508-.0043633 14.9140364-5.1908476 17.2147692-12.7740627 2.3007328-7.5832152-.6285848-15.7790451-7.2147692-20.1859373z",
    fill: "#040040",
    "data-original": "#0377bc",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m28.042 41h11.958c.5522847 0 1-.4477153 1-1v-11.958c-.0019755-.2823753-.1219572-.5510558-.3309031-.7410066s-.4878116-.2838589-.7690969-.2589934c-6.8636347.5429736-12.3145603 5.9943231-12.857 12.858-.0248524.2811132.0689234.5598191.2586542.7687318.1897307.2089127.4581452.329015.7403458.3312682z",
    fill: "#f5f5f5",
    "data-original": "#f5f5f5",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m51 3v23.04c-6.4111679-4.2897867-14.843039-4.017516-20.9640997.6769446-6.1210606 4.6944605-8.5703591 12.7673484-6.089673 20.0715622 2.4806862 7.3042138 9.3398032 12.2157406 17.0537727 12.2114932h-34c-1.10320187-.0032948-1.9967052-.8967981-2-2v-54c.0032948-1.10320187.89679813-1.9967052 2-2h42c1.1032019.0032948 1.9967052.89679813 2 2z",
    fill: "#f5f5f5",
    "data-original": "#f5f5f5",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m23 41c.0040878-9.377993 7.2107984-17.1800764 16.559-17.927-.515-.044-1.033-.073-1.559-.073-9.9411255 0-18 8.0588745-18 18s8.0588745 18 18 18h3c-9.9411255 0-18-8.0588745-18-18z",
    fill: "#f5f5f5",
    "data-original": "#cfd8dc",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m49 1h-3c1.1032019.0032948 1.9967052.89679813 2 2v21.428c1.048866.4409628 2.0533931.9807287 3 1.612v-23.04c-.0032948-1.10320187-.8967981-1.9967052-2-2z",
    fill: "#f5f5f5",
    "data-original": "#cfd8dc",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 30,
    fill: "#ffffff",
    r: 2,
    "data-original": "#9e9e9e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 20,
    fill: "#ffffff",
    r: 2,
    "data-original": "#9e9e9e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    fill: "#ffffff",
    r: 2,
    "data-original": "#9e9e9e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 50,
    fill: "#ffffff",
    r: 2,
    "data-original": "#9e9e9e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 40,
    fill: "#ffffff",
    r: 2,
    "data-original": "#9e9e9e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52 25.537v-22.537c0-1.65685425-1.3431458-3-3-3h-42c-1.65685425 0-3 1.34314575-3 3v6h-3c-.55228475 0-1 .44771525-1 1 0 .5522847.44771525 1 1 1h3v8h-3c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h3v8h-3c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h3v8h-3c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h3v8h-3c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h3v6c0 1.6568542 1.34314575 3 3 3h34c8.2663883.0082075 15.5875344-5.3344695 18.1010924-13.2094469 2.5135581-7.8749773-.3585412-16.4711639-7.1010924-21.2535531zm-35 32.463v-1c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v1h-8c-.55228475 0-1-.4477153-1-1v-6h1.184c.4870363 1.3775467 1.89566623 2.2038721 3.3357331 1.9567957 1.4400668-.2470764 2.492694-1.4956868 2.492694-2.9567957s-1.0526272-2.7097193-2.492694-2.9567957c-1.44006687-.2470764-2.8486968.579249-3.3357331 1.9567957h-1.184v-8h1.184c.4870363 1.3775467 1.89566623 2.2038721 3.3357331 1.9567957 1.4400668-.2470764 2.492694-1.4956868 2.492694-2.9567957s-1.0526272-2.7097193-2.492694-2.9567957c-1.44006687-.2470764-2.8486968.579249-3.3357331 1.9567957h-1.184v-8h1.184c.4870363 1.3775467 1.89566623 2.2038721 3.3357331 1.9567957 1.4400668-.2470764 2.492694-1.4956868 2.492694-2.9567957s-1.0526272-2.7097193-2.492694-2.9567957c-1.44006687-.2470764-2.8486968.579249-3.3357331 1.9567957h-1.184v-8h1.184c.4870363 1.3775467 1.89566623 2.2038721 3.3357331 1.9567957 1.4400668-.2470764 2.492694-1.4956868 2.492694-2.9567957s-1.0526272-2.7097193-2.492694-2.9567957c-1.44006687-.2470764-2.8486968.579249-3.3357331 1.9567957h-1.184v-8h1.184c.4870363 1.3775467 1.89566623 2.2038721 3.3357331 1.9567957 1.4400668-.2470764 2.492694-1.4956868 2.492694-2.9567957s-1.0526272-2.70971927-2.492694-2.95679568c-1.44006687-.24707641-2.8486968.57924899-3.3357331 1.95679568h-1.184v-6c0-.55228475.44771525-1 1-1h8v1c0 .55228475.4477153 1 1 1s1-.44771525 1-1v-1h32c.5522847 0 1 .44771525 1 1v21.273c-2.4685881-1.3255207-5.2014211-2.084565-8-2.222v-1.051h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-6c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h2v1.051c-8.6219926.44051-15.8588506 6.6477517-17.6071532 15.1021141-1.7483026 8.4543625 2.4330471 17.0228091 10.1731532 20.8468859zm-8-8c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-.55228475 0-1-.4477153-1-1zm0-10c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-.55228475 0-1-.4477153-1-1zm0-10c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-.55228475 0-1-.4477153-1-1zm0-10c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-.55228475 0-1-.4477153-1-1zm0-10c0-.55228475.44771525-1 1-1 .5522847 0 1 .44771525 1 1 0 .5522847-.4477153 1-1 1-.55228475 0-1-.4477153-1-1zm32 48c-9.3888407 0-17-7.6111593-17-17s7.6111593-17 17-17 17 7.6111593 17 17c-.010471 9.3845001-7.6154999 16.989529-17 17z",
    fillRule: "nonzero",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39.819 26.046c-7.3345363.620697-13.1528355 6.4394186-13.773 13.774-.0443548.5651351.148791 1.1231925.533 1.54.3776543.4072086.9076257.6390484 1.463.64h11.958c1.1045695 0 2-.8954305 2-2v-11.958c-.0009516-.5553743-.2327914-1.0853457-.64-1.463-.4176215-.3835189-.9756691-.576536-1.541-.533zm.181 13.954h-11.958v-.024c.5379332-6.3639089 5.5930232-11.4088532 11.958-11.934z",
    fillRule: "nonzero",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 6c-.5522847 0-1 .44771525-1 1v1c0 .55228475.4477153 1 1 1s1-.44771525 1-1v-1c0-.55228475-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 11c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 16c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 21c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 26c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 31c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 36c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 41c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 46c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m16 51c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m22 10h23c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-23c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m22 16h4c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m41 14h-11c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h11c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m32 22c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-10c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTask);
export default __webpack_public_path__ + "static/media/time-task.efeda1d5947dafe17379a4d3c479769d.svg";
export { ForwardRef as ReactComponent };